// Do-Not-Ship enforcement shared by every courier manager. Reads the small
// doNotShipIndex/{mobileLast10} node — never loads the full customerBase.
import { getDatabase, ref, get, update } from 'firebase/database';
import { getAuth } from 'firebase/auth';
import { recordTimelineEvent } from '../../../core/customer/CustomerTimelineEngine';

export const norm10 = (m) => String(m || '').replace(/\D/g, '').slice(-10);

// Only these roles may override a Do-Not-Ship flag at the courier step.
export const OVERRIDE_ROLES = new Set(['admin', 'super_admin', 'manager']);

async function loadIndex(path) {
    const map = new Map();
    try {
        const snap = await get(ref(getDatabase(), path));
        if (snap.exists()) {
            Object.entries(snap.val() || {}).forEach(([m10, v]) => map.set(m10, v || {}));
        }
    } catch (e) { /* fail-open to empty: callers simply find nothing flagged */ }
    return map;
}

export const loadDoNotShipIndex = () => loadIndex('doNotShipIndex');
export const loadRefundGivenIndex = () => loadIndex('refundGivenIndex');

export const flagFor = (index, order) => index?.get?.(norm10(order?.customer?.mobile));

export const flaggedOrders = (orders, index) =>
    (orders || []).map(o => ({ order: o, flag: flagFor(index, o) })).filter(x => x.flag);

// Audit an override on the order + the customer timeline.
export async function recordDoNotShipOverride(order, flag, reason) {
    const db = getDatabase();
    const key = order.firebaseKey || order.id;
    const u = getAuth().currentUser;
    const by = u?.displayName || u?.email || 'admin';
    const at = new Date().toISOString();
    try {
        await update(ref(db, `orders/${key}/doNotShipOverride`), {
            overridden: true,
            reason: reason || '',
            overriddenBy: by,
            overriddenAt: at,
            originalFlagReason: flag?.reason || '',
            originalFlagNote: flag?.note || '',
        });
    } catch (e) { console.warn('[DoNotShip] override audit failed:', e.message); }
    try {
        const mobile = order.customer?.mobile;
        if (mobile) {
            await recordTimelineEvent(mobile, 'do_not_ship_override', {
                note: `Do Not Ship override — ${flag?.reason || ''}${reason ? ` · ${reason}` : ''} (by ${by})`,
                status: 'override', source: 'shipping', orderId: order.id || key,
            }, by);
        }
    } catch (e) { /* timeline best-effort */ }
}
